import React, { Component } from 'react';

import PropTypes from 'prop-types';

export default class CancellationPolicyBlock extends Component {
  static propTypes = {
    paymentOptions: PropTypes.object,
    t: PropTypes.func,
  };

  render() {
    const { t, paymentOptions } = this.props;
    return (
      <div className="cancellation-cancellation-policy-block font10">
        <div className="pol-title">
          <span className="bold-text upper-case-text">
            {t('CANCEL_TICKET.IMPORTANT_INFORMATION')}
          </span>
        </div>
        {paymentOptions && paymentOptions.paypalSelected ? (
          <div>
            {' '}
            <span className="bold-text ">{t('CANCEL_TICKET.PAYPAL_REFUND.BOLD')}</span>{' '}
            {t('CANCEL_TICKET.PAYPAL_REFUND.NORMAL')}
          </div>
        ) : null}
        {paymentOptions && paymentOptions.pbCashSelected ? (
          <div>
            {' '}
            <span className="bold-text ">{t('CANCEL_TICKET.KUPOSPAY_REFUND.BOLD')}</span>{' '}
            {t('CANCEL_TICKET.KUPOSPAY_REFUND.NORMAL')}
          </div>
        ) : null}
        {paymentOptions && paymentOptions.bankSelected ? (
          <div>
            {' '}
            <span className="bold-text ">{t('CANCEL_TICKET.DEPOSIT_REFUND.BOLD')}</span>{' '}
            {t('CANCEL_TICKET.DEPOSIT_REFUND.NORMAL')}
          </div>
        ) : null}
        {paymentOptions && paymentOptions.creditCardSelected ? (
          <div>
            {' '}
            <span className="bold-text ">{t('CANCEL_TICKET.CREDIT_CARD_REFUND.BOLD')}</span>{' '}
            {t('CANCEL_TICKET.CREDIT_CARD_REFUND.NORMAL')}
          </div>
        ) : null}
        <div className="pol-title">
          <span className="bold-text  upper-case-text">
            {t('CANCEL_TICKET.CANCELLATION_POLICIES')}
          </span>
        </div>
        <ul className="sub-item-list my-1">
          <li>
            <span className="bullet">•</span> <span>{t('CANCEL_TICKET.POLICY_BUS_1')}</span>
          </li>
          <li>
            <span className="bullet">•</span> <span>{t('CANCEL_TICKET.POLICY_BUS_2')}</span>
          </li>
          <li>
            <span className="bullet">•</span> <span>{t('CANCEL_TICKET.POLICY_BUS_3')}</span>
          </li>
          {/* <li>
            <span className="bullet">•</span> <span>{t('CANCEL_TICKET.POLICY_BUS_4')}</span>
          </li> */}
          <li>
            <span className="bullet">•</span> <span>{t('CANCEL_TICKET.POLICY_BUS_5')}</span>
          </li>
          {/* <li>
            <span className="bullet">•</span> <span>{t('CANCEL_TICKET.POLICY6')}</span>
          </li> */}
        </ul>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/features/cancellation/CancellationPolicyBlock.js